/**
 * Canicule : rotating heat tips strip
 */
(function () {
  'use strict';

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initSection(section) {
    var tips = section.querySelectorAll('[data-canicule-heat-tip]');
    if (tips.length < 2) return;

    var interval = parseInt(section.getAttribute('data-rotate-interval'), 10) || 8;
    var index = 0;

    function showTip(next) {
      tips[index].classList.remove('is-active');
      index = next;
      tips[index].classList.add('is-active');
    }

    if (reducedMotion) return;

    window.setInterval(function () {
      showTip((index + 1) % tips.length);
    }, interval * 1000);
  }

  function init() {
    document.querySelectorAll('[data-canicule-heat-tips]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
